import { defineGameCard, onResolve, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
import { plannedUnitId } from './slime-helpers.js';
const planning = planningTargets((_context, previous) => {
    const receiver = previous.find((step) => step.stepId === 'receiver')?.selection[0];
    return [
        targetStep('receiver', unitTarget({
            side: 'ally',
            cardinality: { min: 1, max: 1 },
            where: ({ unit }) => unit.traits.includes('SLIME'),
        })),
        targetStep('donor', unitTarget({
            side: 'any',
            cardinality: { min: 1, max: 1 },
            where: ({ unit }) => receiver?.kind === 'unit'
                && unit.instanceId !== receiver.instanceId
                && unit.traits.includes('SLIME'),
        })),
    ];
});
export const ForeignFleshCard = defineGameCard({
    id: 'foreign_flesh',
    gameplay: { type: 'SPELL', cost: 3, planning },
    presentation: {
        name: 'Чужая плоть',
        description: 'Выберите вашего слизня и другого слизня в любых локациях. Первый поглощает второго и получает его атаку и оставшееся здоровье, но не способности.',
        glyph: {
            colors: ['#10213A', '#4D85B5', '#6AABDE', '#69A2B3', '#3E647A'],
            rows: [
                '.......111111.......',
                '.....1122233311.....',
                '....122333333331....',
                '...12333333333321...',
                '..1233113333113221..',
                '.123333333333333221.',
                '.123333333333333421.',
                '.123333333334343321.',
                '.1233333335433333421',
                '12333333554443343221',
                '12333335444444333221',
                '13333354414444532221',
                '13333354444445222221',
                '13333354414452222221',
                '13333335555522222221',
                '.133333333322222221.',
                '.133333332222222221.',
                '..1132222222222211..',
                '....111111111111....',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [onResolve((ctx) => {
            const receiverId = plannedUnitId(ctx, 'receiver');
            const donorId = plannedUnitId(ctx, 'donor');
            if (receiverId !== undefined && donorId !== undefined)
                ctx.ops.absorbCards(receiverId, [donorId]);
        })],
    ui: {
        mechanics: ['absorb'],
        planning: {
            steps: {
                receiver: { label: 'Выберите слизня-получателя' },
                donor: { label: 'Выберите слизня-донора в любой локации' },
            },
        },
    },
});
//# sourceMappingURL=foreign_flesh.js.map